import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "c-filter-bar py-40px bg-white" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col" };
const _hoisted_5 = { class: "d-flex flex-wrap gap-4 mb-40px flex-md-row flex-column" };
const _hoisted_6 = { class: "c-filter-bar__item d-flex gap-4 c-filter-bar__item--2" };
const _hoisted_7 = { class: "c-filter-bar__item" };
const _hoisted_8 = {
    class: "form-label h6 mb-3",
    for: "filter-date-picker"
};
const _hoisted_9 = ["placeholder"];
const _hoisted_10 = { class: "text-center" };
const _hoisted_11 = { class: "l-stores py-40px py-lg-80px" };
const _hoisted_12 = { class: "container" };
const _hoisted_13 = { class: "row" };
const _hoisted_14 = { class: "col" };
const _hoisted_15 = {
    key: 0,
    class: "c-region-tabs d-flex flex-wrap gap-2 mb-40px"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
    key: 1,
    class: "text-center"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("span", {
    class: "spinner-border spinner-border-sm",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("span", null, "Loading...", -1);
const _hoisted_20 = [
    _hoisted_18,
    _hoisted_19
];
const _hoisted_21 = { key: 2 };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("div", {
    class: "card border-0 bg-white justify-content-center align-items-center",
    style: { "height": "296px" }
}, [
    /*#__PURE__*/ _createElementVNode("span", {
        class: "spinner-border spinner-border-sm",
        "aria-hidden": "true"
    }),
    /*#__PURE__*/ _createElementVNode("span", null, "Loading...")
], -1);
const _hoisted_23 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center gap-3 pt-40px"
};
const _hoisted_24 = ["disabled"];
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("span", null, "‹", -1);
const _hoisted_26 = [
    _hoisted_25
];
const _hoisted_27 = { class: "px-2" };
const _hoisted_28 = ["disabled"];
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("span", null, "›", -1);
const _hoisted_30 = [
    _hoisted_29
];
import SelectField from '@vue/components/form/SelectField.vue';
import StoreCard from '@vue/components/StoreCard.vue';
import { MainStore } from '@vue/services/store';
import { $lang, taipeiNow } from '@vue/services/utilities';
import dayjs from 'dayjs';
import { computed, inject, onMounted, ref, watch } from 'vue';
import flatpickr from 'flatpickr';
import { MandarinTraditional } from 'flatpickr/dist/l10n/zh-tw';
import 'flatpickr/dist/flatpickr.min.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SearchList',
    props: {
        brands: {},
        stores: {}
    },
    emits: ['toReservationForm'],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        const locale = inject('locale');
        // 單品牌站不顯示品牌下拉（品牌已由 .env SITE_BRAND_ID 決定）
        const brandLocked = inject('brandLocked', false);
        const loading = ref(false);
        const selectFieldKey = ref(0);
        const props = __props;
        const filters = ref({
            brandId: MainStore.brandId,
            storeId: MainStore.storeId ? MainStore.storeId : '',
            adults: MainStore.adults ? MainStore.adults : 1,
            children: MainStore.children ? MainStore.children : 0,
            date: MainStore.date ? MainStore.date : '',
        });
        const filterDatePicker = ref();
        const limit = ref(8);
        onMounted(() => {
            currentStores.value = props.stores.filter((v) => {
                return v.brandId === filters.value.brandId
                    && v.status === 1; // ★
            });
            initFilterDatePicker();
            applyLimit();
            requestNearestStore(); // 進站詢問定位；命中最近店（且未選店）才收斂
        });
        watch(() => props.stores, (value) => {
            if (value) {
                currentStores.value = value.filter((v) => {
                    return v.brandId === filters.value.brandId
                        && v.status === 1; // ★
                });
                applyLimit();
                applyNearestIfIdle(); // 門店較晚載入時，座標已就緒就套用最近店
            }
        });
        watch(() => props.brands, (value) => {
            /*if (value) {
              const brand = value.filter((v) => {
                return v.id === filters.value.brandId;
              });
          
              brandLimit(brand[0].en.title);
            }*/
            if (value) {
                applyLimit();
            }
        });
        const brandOptions = computed(() => {
            return props.brands.map((v) => {
                return {
                    text: locale === 'zh-TW' ? v.tw.title : v.en.title,
                    value: v.id
                };
            });
        });
        const storeOptions = computed(() => {
            const stores = props.stores.filter((v) => {
                return v.brandId === filters.value.brandId
                    && v.status === 1; // ★ 只留啟用店家
            });
            return stores.map((v) => {
                return {
                    text: locale === 'zh-TW' ? v.tw.title : v.en.title,
                    value: v.id
                };
            });
        });
        // 修正 computed，加入安全檢查
        const adultOptions = computed(() => {
            const options = [];
            const childrenCount = filters.value.children || 0;
            const max = Math.max(1, limit.value - childrenCount);
            for (let i = 1; i <= max; i++) {
                options.push({
                    text: i + $lang('app.reservation.option.adult'),
                    value: i
                });
            }
            return options;
        });
        const childrenOptions = computed(() => {
            const options = [];
            const adultsCount = filters.value.adults || 1;
            const max = Math.max(0, limit.value - adultsCount);
            for (let i = 0; i <= max; i++) {
                options.push({
                    text: i + $lang('app.reservation.option.child'),
                    value: i
                });
            }
            return options;
        });
        // 新增：監聽 limit 變化，確保選項更新
        /*
        watch(() => limit.value, (newLimit) => {
          const currentTotal = filters.value.adults + filters.value.children;
          if (currentTotal > newLimit) {
            // 如果當前總數超過新限制，調整數值
            const maxAdults = Math.min(filters.value.adults, newLimit - 1);
            const maxChildren = Math.max(0, newLimit - maxAdults);
        
            filters.value.adults = maxAdults;
            filters.value.children = Math.min(filters.value.children, maxChildren);
          }
        });
        */
        watch(() => limit.value, (newLimit) => {
            const adults = filters.value.adults ?? 1;
            const children = filters.value.children ?? 0;
            const currentTotal = adults + children;
            if (currentTotal > newLimit) {
                const maxAdults = Math.min(adults, newLimit - 1);
                const maxChildren = Math.max(0, newLimit - maxAdults);
                filters.value.adults = maxAdults;
                filters.value.children = Math.min(children, maxChildren);
            }
        });
        // 修正 updateFilters 函數
        //20251222 更換讀取人數
        /*function updateFilters<T extends keyof MainStoreType>(key: T, value: MainStoreType[T]) {
          let val = value;
        
          if (
            key === 'storeId' && val !== ''
            || key === 'adults' && val !== ''
            || key === 'children' && val !== ''
          ) {
            val = parseInt(val as string) as MainStoreType[T];
          }
        
          if (key === 'storeId') {
            updateDateRange(val);
          }
          
          if (key === 'brandId') {
            const brand = props.brands.filter((v) => {
              return v.id === val;
            });
        
            // 先設定新的 filter 值
            //filters.value[key] = val;
        
            // 再呼叫 brandLimit，這樣才能正確更新店家列表和限制
            brandLimit(brand[0].en.title);
            // 重新設定 storeId 為空字串，因為品牌變了
            filters.value.storeId = '' as MainStoreType[T];
          } else {
            // 對於其他 key，正常設定值
            filters.value[key] = val;
          }
        
          updateCard();
        }
        */
        function updateFilters(key, value) {
            let val = value;
            if ((key === 'storeId' || key === 'adults' || key === 'children') &&
                typeof val === 'string' &&
                val !== '') {
                val = parseInt(val, 10);
            }
            if (key === 'brandId') {
                filters.value.brandId = val;
                filters.value.storeId = ''; // 品牌變更先清店家
                currentRegion.value = ''; // 品牌變更回到「全部」地區
                userPickedStore.value = false; // 換品牌＝新情境，允許重算最近店
                applyLimit(); // 回到品牌預設 limit
            }
            else {
                filters.value[key] = val;
            }
            if (key === 'storeId') {
                updateDateRange(val);
                applyLimit(); // 這次會用到新的 storeId
            }
            updateCard();
            if (key === 'brandId') {
                applyNearestIfIdle(); // 換品牌後用快取座標重算最近店（不重複彈權限）
            }
        }
        /*
        function updateDateRange(val: string) {
          const today = dayjs();
        
          if (val !== '') {
            const store = currentStores.value.find((v) => v.id === parseInt(val));
        
            const maxDate = today.add(store!.maxReserveLimit!, 'day').format('YYYY-MM-DD');
        
            filterDatePicker.value._flatpickr.set('maxDate', maxDate)
          } else {
            const maxDate = today.add(30, 'day').format('YYYY-MM-DD');
        
            filterDatePicker.value._flatpickr.set('maxDate', maxDate)
          }
        }*/
        function updateDateRange(val) {
            // 日曆可訂日以台灣日期為準（國外裝置今天可能與台灣差一天）
            const today = taipeiNow();
            const storeId = Number(val);
            if (!Number.isNaN(storeId) && storeId !== 0) {
                const store = currentStores.value.find((v) => v.id === storeId);
                const maxDate = today.add(store.maxReserveLimit, 'day').format('YYYY-MM-DD');
                filterDatePicker.value._flatpickr.set('maxDate', maxDate);
            }
            else {
                const maxDate = today.add(30, 'day').format('YYYY-MM-DD');
                filterDatePicker.value._flatpickr.set('maxDate', maxDate);
            }
        }
        function updateCard() {
            loading.value = true;
            currentPage.value = 1;
            currentStores.value = props.stores.filter((v) => {
                return v.brandId === filters.value.brandId
                    && v.status === 1; // ★
            });
            //20251222 更改來源後
            //filters.storeId 有可能是 '' | number
            if (filters.value.storeId) {
                currentStoreId.value = filters.value.storeId;
                u.trigger(`update.card.value.${currentStoreId.value}`);
            }
            else {
                currentStoreId.value = 0;
                currentStores.value.forEach((v) => {
                    u.trigger(`update.card.value.${v.id}`);
                });
            }
            setTimeout(() => {
                loading.value = false;
            }, 100);
        }
        function initFilterDatePicker() {
            // 日曆 minDate/maxDate 以台灣日期為準（國外裝置今天可能與台灣差一天）
            const today = taipeiNow();
            const minDate = today.format('YYYY-MM-DD');
            const maxDate = today.add(30, 'day').format('YYYY-MM-DD');
            let defaultDate = undefined;
            if (filters.value.date !== '') {
                defaultDate = filters.value.date;
            }
            flatpickr('#filter-date-picker', {
                locale: locale === 'zh-TW' ? MandarinTraditional : undefined,
                minDate: minDate,
                maxDate: maxDate,
                defaultDate: defaultDate,
            });
        }
        const currentStoreId = ref(MainStore.storeId);
        const currentStores = ref([]);
        // 分頁：多店並列時每頁最多顯示 perPage 家門店
        const currentPage = ref(1);
        const perPage = ref(4);
        // 地區分頁（對齊狂一鍋）：''＝全部；空 region 的門店只出現在「全部」。
        const REGION_ORDER = ['north', 'central', 'south', 'east'];
        const currentRegion = ref('');
        // 該品牌實際有店的地區（固定順序）；沒有任何店設地區時回空 → 不顯示分頁列。
        const presentRegions = computed(() => {
            return REGION_ORDER.filter((r) => currentStores.value.some((s) => (s.region || '') === r));
        });
        function regionLabel(r) {
            return $lang('app.reservation.region.' + (r || 'all'));
        }
        function selectRegion(r) {
            userPickedStore.value = true; // 手動切地區 → geolocation 不再自動覆蓋
            currentRegion.value = r;
            currentPage.value = 1;
            // 若目前收斂在單店（手選或定位命中），切地區時解除，改列該區全部門店
            if (filters.value.storeId) {
                filters.value.storeId = '';
                selectFieldKey.value++; // 同步清空門店下拉顯示
                updateCard(); // currentStoreId←0，改以地區重畫
            }
        }
        // 換品牌後若目前選的地區已無店 → 退回全部
        watch(presentRegions, (regions) => {
            if (currentRegion.value && !regions.includes(currentRegion.value)) {
                currentRegion.value = '';
            }
        });
        // 要顯示的門店：指定單店（下拉選店或深連結帶 storeId）→ 只留該店；
        // 否則列出該品牌門店，再套用地區分頁；不再有「未選店 → 空白」的狀態。
        const displayStores = computed(() => {
            if (currentStoreId.value) {
                return currentStores.value.filter((v) => v.id === currentStoreId.value);
            }
            if (currentRegion.value) {
                return currentStores.value.filter((s) => (s.region || '') === currentRegion.value);
            }
            return currentStores.value;
        });
        const totalPages = computed(() => {
            return Math.max(1, Math.ceil(displayStores.value.length / perPage.value));
        });
        const pagedStores = computed(() => {
            const start = (currentPage.value - 1) * perPage.value;
            return displayStores.value.slice(start, start + perPage.value);
        });
        function goToPage(p) {
            if (p < 1 || p > totalPages.value) {
                return;
            }
            currentPage.value = p;
        }
        // 開定位找最近門店：命中即收斂成最近單店；使用者手選/深連結不覆蓋；沒開定位不推送。
        const userPickedStore = ref(false);
        const geoPos = ref(null);
        function haversineKm(aLat, aLng, bLat, bLng) {
            const toRad = (d) => (d * Math.PI) / 180;
            const R = 6371;
            const dLat = toRad(bLat - aLat);
            const dLng = toRad(bLng - aLng);
            const s = Math.sin(dLat / 2) ** 2
                + Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLng / 2) ** 2;
            return 2 * R * Math.asin(Math.min(1, Math.sqrt(s)));
        }
        // 最近門店：只納入有座標的；距離差 < 50m 視為同址，改用 ordering ASC 決定（板前優先）。
        function findNearestStore(stores, pos) {
            const withGeo = stores.filter((s) => s.lat != null && s.lng != null);
            if (!withGeo.length) {
                return null;
            }
            return withGeo
                .map((s) => ({
                s,
                d: haversineKm(pos.lat, pos.lng, Number(s.lat), Number(s.lng)),
            }))
                .sort((a, b) => {
                if (Math.abs(a.d - b.d) > 0.05) {
                    return a.d - b.d;
                }
                return (Number(a.s.ordering) || 0) - (Number(b.s.ordering) || 0);
            })[0].s;
        }
        // 只有「未選店且未被手選/深連結」時才套用；否則不覆蓋。
        function applyNearestIfIdle() {
            if (userPickedStore.value || filters.value.storeId || !geoPos.value) {
                return;
            }
            const nearest = findNearestStore(currentStores.value, geoPos.value);
            if (!nearest) {
                return;
            }
            filters.value.storeId = nearest.id;
            if (nearest.region) {
                currentRegion.value = nearest.region; // 地區 tab highlight 到最近店所在區
            }
            updateDateRange(nearest.id);
            applyLimit();
            selectFieldKey.value++; // 讓門店下拉顯示自動選到的店
            updateCard();
        }
        function requestNearestStore() {
            if (!('geolocation' in navigator)) {
                return; // 不支援 → 不推送
            }
            navigator.geolocation.getCurrentPosition((p) => {
                geoPos.value = { lat: p.coords.latitude, lng: p.coords.longitude };
                applyNearestIfIdle();
            }, () => { }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
        }
        // 手選門店（含清空選「全部」）→ 之後不再自動覆蓋
        function onStorePicked(v) {
            userPickedStore.value = true;
            updateFilters('storeId', v);
        }
        function reserve(v) {
            v.adults = filters.value.adults;
            v.children = filters.value.children;
            emits('toReservationForm', v);
        }
        // 2. 修正 brandLimit 函數
        /*function brandLimit(brandTitle: string|undefined) {
          const newLimit = brandTitle === 'MinSuiZen' ? 6 : 8;
        
          if (limit.value !== newLimit) {
            limit.value = newLimit;
        
            // 重置人數確保不超過新的限制
            const currentTotal = filters.value.adults! + filters.value.children!;
            if (currentTotal > newLimit) {
              // 重置為最小值
              filters.value.adults = 1;
              filters.value.children = 0;
            }
        
            // 強制重新渲染 SelectField
            selectFieldKey.value++;
          }
        }*/
        //20251222 更改客戶可選人數
        function brandLimit() {
            applyLimit();
        }
        function getBrandDefaultLimit(brandId) {
            const brand = props.brands.find((b) => b.id === brandId);
            const brandTitle = brand?.en?.title;
            return brandTitle === 'MinSuiZen' ? 6 : 8;
        }
        function applyLimit() {
            // 先拿品牌預設
            let newLimit = getBrandDefaultLimit(filters.value.brandId);
            // 如果有選店，且該店有 maxCustomer（>0），就用店家設定
            if (filters.value.storeId) {
                const store = props.stores.find((s) => s.id === Number(filters.value.storeId));
                const storeLimit = Number(store?.maxCustomer);
                if (!Number.isNaN(storeLimit) && storeLimit > 0) {
                    newLimit = storeLimit;
                }
            }
            if (limit.value !== newLimit) {
                limit.value = newLimit;
                // 確保目前選的人數不超過上限
                const adults = filters.value.adults ?? 1;
                const children = filters.value.children ?? 0;
                const currentTotal = adults + children;
                if (currentTotal > newLimit) {
                    filters.value.adults = 1;
                    filters.value.children = 0;
                }
                // 強制重新渲染 SelectField（原本就有）
                selectFieldKey.value++;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("section", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    (!_unref(brandLocked) && brandOptions.value.length)
                                        ? (_openBlock(), _createBlock(SelectField, {
                                            key: 0,
                                            name: "brand",
                                            class: "c-filter-bar__item",
                                            options: brandOptions.value,
                                            label: _unref($lang)('app.reservation.label.brand'),
                                            "default-value": filters.value.brandId,
                                            onUpdate: _cache[0] || (_cache[0] = ($event) => (updateFilters('brandId', $event)))
                                        }, null, 8, ["options", "label", "default-value"]))
                                        : _createCommentVNode("", true),
                                    (storeOptions.value.length)
                                        ? (_openBlock(), _createBlock(SelectField, {
                                            name: "store",
                                            key: `store-${selectFieldKey.value}`,
                                            class: "c-filter-bar__item",
                                            "empty-options": true,
                                            "clear-when-options-change": true,
                                            options: storeOptions.value,
                                            label: _unref($lang)('app.reservation.label.store'),
                                            "default-value": filters.value.storeId,
                                            onUpdate: _cache[1] || (_cache[1] = ($event) => (onStorePicked($event)))
                                        }, null, 8, ["options", "label", "default-value"]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_6, [
                                        (_openBlock(), _createBlock(SelectField, {
                                            name: "adults",
                                            key: `adults-${selectFieldKey.value}`,
                                            class: "w-100",
                                            options: adultOptions.value,
                                            label: _unref($lang)('app.reservation.label.headcount'),
                                            "default-value": filters.value.adults,
                                            sort: false,
                                            onUpdate: _cache[2] || (_cache[2] = ($event) => (updateFilters('adults', $event)))
                                        }, null, 8, ["options", "label", "default-value"])),
                                        (_openBlock(), _createBlock(SelectField, {
                                            name: "children",
                                            key: `children-${selectFieldKey.value}`,
                                            class: "w-100",
                                            label: "用餐人數",
                                            "label-class": "opacity-0",
                                            options: childrenOptions.value,
                                            "default-value": filters.value.children,
                                            sort: false,
                                            onUpdate: _cache[3] || (_cache[3] = ($event) => (updateFilters('children', $event)))
                                        }, null, 8, ["options", "default-value"]))
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("label", _hoisted_8, _toDisplayString(_unref($lang)('app.reservation.label.date')), 1),
                                        _createElementVNode("input", {
                                            ref_key: "filterDatePicker",
                                            ref: filterDatePicker,
                                            type: "text",
                                            class: "w-100 form-control align-items-start",
                                            id: "filter-date-picker",
                                            placeholder: _unref($lang)('app.reservation.placeholder.select.date'),
                                            onInput: _cache[4] || (_cache[4] = ($event) => (updateFilters('date', $event.target?.value)))
                                        }, null, 40, _hoisted_9)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn c-btn-customization-primary",
                                        onClick: updateCard
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(_unref($lang)('app.reservation.btn.search')), 1)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                (presentRegions.value.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass(["btn c-region-tab", { on: currentRegion.value === '' }]),
                                            onClick: _cache[5] || (_cache[5] = ($event) => (selectRegion('')))
                                        }, _toDisplayString(regionLabel('')), 3),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presentRegions.value, (r) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: r,
                                                type: "button",
                                                class: _normalizeClass(["btn c-region-tab", { on: currentRegion.value === r }]),
                                                onClick: ($event) => (selectRegion(r))
                                            }, _toDisplayString(regionLabel(r)), 11, _hoisted_16));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true),
                                (loading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagedStores.value, (store) => {
                                            return (_openBlock(), _createBlock(_Suspense, {
                                                key: `store-` + store.id
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(StoreCard, {
                                                        item: { ...store },
                                                        brands: _ctx.brands,
                                                        filters: filters.value,
                                                        onReserve: reserve
                                                    }, null, 8, ["item", "brands", "filters"])
                                                ]),
                                                fallback: _withCtx(() => [
                                                    _hoisted_22
                                                ]),
                                                _: 2
                                            }, 1024));
                                        }), 128)),
                                        (totalPages.value > 1)
                                            ? (_openBlock(), _createElementBlock("nav", _hoisted_23, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn c-btn-customization-primary btn-sm",
                                                    disabled: currentPage.value <= 1,
                                                    onClick: _cache[6] || (_cache[6] = ($event) => (goToPage(currentPage.value - 1)))
                                                }, _hoisted_26, 8, _hoisted_24),
                                                _createElementVNode("span", _hoisted_27, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value), 1),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn c-btn-customization-primary btn-sm",
                                                    disabled: currentPage.value >= totalPages.value,
                                                    onClick: _cache[7] || (_cache[7] = ($event) => (goToPage(currentPage.value + 1)))
                                                }, _hoisted_30, 8, _hoisted_28)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
